export default __webpack_public_path__ + "static/media/elevate-bbl-2.e384b57c.png";